import { render, staticRenderFns } from "./addRecord.vue?vue&type=template&id=7aa5c05c&scoped=true"
import script from "./addRecord.vue?vue&type=script&lang=js"
export * from "./addRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa5c05c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa5c05c')) {
      api.createRecord('7aa5c05c', component.options)
    } else {
      api.reload('7aa5c05c', component.options)
    }
    module.hot.accept("./addRecord.vue?vue&type=template&id=7aa5c05c&scoped=true", function () {
      api.rerender('7aa5c05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplier/coupons/addRecord.vue"
export default component.exports